import React, { ChangeEvent, ReactNode } from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { InlineFieldRow } from '../InlineFieldRow/InlineFieldRow';

interface TextFieldProps {
    label: ReactNode
    value: string
    onChange: (event: ChangeEvent<HTMLInputElement>) => void
    name?: string
    placeholder?: string
    error?: string
    maxLength?: number
    // Label beside the control on one line instead of above it -- opt-in, existing callers are
    // unaffected (Contest V2's EventForm renders this unchanged).
    inline?: boolean
}

export function TextField(props: TextFieldProps) {
  const {
    label,
    name,
    value,
    onChange,
    error,
    maxLength = 0,
    placeholder,
    inline,
  } = props;

  const hasMaxLength = Boolean(maxLength);
  const isTitleTooLong = hasMaxLength ? value.length > maxLength : false;

  const control = (
    <InputGroup hasValidation>
      <Form.Control
        type="text"
        id={inline ? name : undefined}
        name={name}
        value={value}
        onChange={onChange}
        isInvalid={!!error}
        className={isTitleTooLong ? 'text-limit' : ''}
        placeholder={placeholder}
      />
      {hasMaxLength && (
      <Form.Text className="char-limit-info-box" style={{ top: 0, bottom: 'auto' }}>
        {maxLength - value.length}
      </Form.Text>
      )}
      <Form.Control.Feedback type="invalid">
        {error}
      </Form.Control.Feedback>
    </InputGroup>
  );

  if (inline) {
    return <InlineFieldRow label={label} htmlFor={name}>{control}</InlineFieldRow>;
  }

  return (
    <Form.Group>
      <Form.Label>{label}</Form.Label>
      {control}
    </Form.Group>
  );
}
